export default {"src":"/login-app/[GIT_HASH]/_next/static/media/credit_card.70ad58dc.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};